/** @file Number of drawn tiles of a facet entry: its sector table's tile count, `extendX` included. */
import { tileCountOf } from '@zilo/pose3d-format/tables/tileCountOf';
import type { FacetEntry, SectorTable } from '@zilo/pose3d-format/types/facet';

/** Tiles of `entry` drawn from `table` (its `yaw`); the transposed `extendX` layout keeps the count (18.5). */
export function entryTiles(entry: FacetEntry, table: SectorTable): number {
  return tileCountOf(table);
}
